import { useCreateEntity, useGetEntity } from '@abaninja/util-store';

import { createDeepbox, getDeepbox } from '../deepbox';

export const useDeepboxStore = () => ({
  ...useCreateEntity(createDeepbox),
  ...useGetEntity(getDeepbox),
});
